import { render, staticRenderFns } from "./ChatThread.vue?vue&type=template&id=ae8b69e2&scoped=true"
import script from "./ChatThread.vue?vue&type=script&lang=ts"
export * from "./ChatThread.vue?vue&type=script&lang=ts"
import style0 from "./ChatThread.vue?vue&type=style&index=0&id=ae8b69e2&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae8b69e2",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/winfakt/wf/v2.online.dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ae8b69e2')) {
      api.createRecord('ae8b69e2', component.options)
    } else {
      api.reload('ae8b69e2', component.options)
    }
    module.hot.accept("./ChatThread.vue?vue&type=template&id=ae8b69e2&scoped=true", function () {
      api.rerender('ae8b69e2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/chat/ChatThread.vue"
export default component.exports